import React, { useState } from "react";
import { Grid, Icon, Header, Label, Button, Message } from "semantic-ui-react";
import "../../components/SharedCard.css";

const ClaimCard = ({ claim, idx }) => {
    const [showContent, setShowContent] = useState(false);
    const toggleContent = () => setShowContent(!showContent);

    const isCorrect = claim.verification === "Correct";
    const color = isCorrect ? "green" : claim.verification === "Incorrect" ? "red" : "grey";
    const labelText = isCorrect ? "정확함" : claim.verification === "Incorrect" ? "오류" : claim.verification;

    return (
        <div className="custom-card" style={{ padding: 0, overflow: 'hidden', marginBottom: '1em' }}>
             {/* Header Section (Collapsed) */}
             <div 
                style={{ 
                    padding: '1.5em', 
                    display: 'flex', 
                    alignItems: 'flex-start', 
                    cursor: 'pointer', 
                    width: '100%',
                    backgroundColor: 'white' 
                }}
                onClick={toggleContent}
             >
                 <div style={{ paddingTop: '0.2em' }}>
                    <Icon 
                        name={showContent ? "chevron down" : "chevron right"} 
                        style={{ marginRight: '10px', color: 'grey', flexShrink: 0 }}
                    />
                 </div>
                 
                 <div style={{ flexGrow: 1, minWidth: 0 }}>
                    <div style={{ marginBottom: '0.3em' }}>
                        <Header as="h5" style={{ margin: 0, wordBreak: 'keep-all', lineHeight: '1.4em', color: '#1d1d1f' }}>
                             <span style={{ color: 'grey', marginRight: '0.5em', fontWeight: 'normal' }}>
                                주장 {idx + 1}.
                             </span>
                             {claim.text}
                        </Header>
                    </div>
                 </div>

                 <div style={{ marginLeft: '1em', flexShrink: 0, paddingTop: '0.2em' }}>
                    <Label circular color={color} size="small">
                        {labelText}
                    </Label>
                 </div>
             </div>

             {/* Expanded Content */}
             {showContent && (
                 <div style={{ padding: '1.5em', borderTop: '1px solid rgba(0,0,0,0.05)', backgroundColor: '#fdfdfd' }}>
                     {/* Verification Reasoning */}
                     <Header as="h5" style={{ color: '#1d1d1f' }}>검증 결과</Header>
                     <p style={{ color: '#424245', marginBottom: '1em', lineHeight: '1.5' }}>{claim.reasoning}</p>
                     
                     {/* Citation */}
                     {claim.citation && (
                        <div style={{ marginTop: '1em' }}>
                             <Button 
                               as="a" 
                               href={claim.citation} 
                               target="_blank" 
                               rel="noopener noreferrer"
                               size="mini"
                               basic
                               icon
                               labelPosition="left"
                             >
                                <Icon name="external" />
                                출처 확인하기
                             </Button>
                        </div>
                     )}
                 </div>
             )}
        </div>
    )
}

const ProductKnowledgeCriteriaList = ({ pkEvaluation }) => {
  if (!pkEvaluation) {
    return <Message info>이 세션에 대한 제품 지식 평가가 없습니다.</Message>;
  }

  const { extracted_claims } = pkEvaluation;

  return (
    <>
      <Header as="h4" style={{ marginBottom: '1em', marginLeft: '0.5em', color: '#666' }}>추출된 주장</Header>
      {extracted_claims && extracted_claims.length > 0 ? (
        <Grid columns={1}>
          {extracted_claims.map((claim, idx) => (
            <Grid.Row key={idx} style={{ paddingTop: "0.5em", paddingBottom: "0.5em" }}>
                 <Grid.Column>
                     <ClaimCard claim={claim} idx={idx} />
                 </Grid.Column>
            </Grid.Row>
          ))}
        </Grid>
      ) : (
        <p style={{ padding: '1em' }}>추출된 주장이 없습니다.</p>
      )}
    </>
  );
};

export default ProductKnowledgeCriteriaList;
